import PropTypes from 'prop-types'
import BaseButton from "./Button.jsx"

export default function PrimaryRoundedButton({children, ...props}) {
  return (
    <BaseButton color={"btn btn btn-outline-primary btn-round btn-sm"} {...props}>
      {children}
    </BaseButton>
  )
}

PrimaryRoundedButton.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.element),
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.element.isRequired,
    PropTypes.node.isRequired
  ]),
  className: PropTypes.string,
  type: PropTypes.string
}